export enum UserMutationTypes {
    SET_NAME = 'SET_NAME',
    SET_USERINFO = 'SET_USERINFO', // 设置用户名
    SET_SHOPRULEDATA = 'SET_SHOPRULEDATA', // 设置商户规范弹框
    SET_EXPRESSMSG = 'SET_EXPRESSMSG', 
    SET_PROMOTIONMSG = 'SET_PROMOTIONMSG', // 设置促销活动弹窗
    SET_STALEDATEMSG = 'SET_STALEDATEMSG', // 设置商户资质过期提醒弹窗
    SET_OBLIGATIONMSG = 'SET_OBLIGATIONMSG', // 未付款提醒弹窗
    SET_RECONCLIATIONMSG = 'SET_RECONCLIATIONMSG',//对账提醒弹窗
    SET_CATROLE = 'SET_CATROLE', // //1，电子券  2，实物 3, 都有
    SET_STOCKMSG = 'SET_STOCKMSG',  //设置库存不足下架提醒弹窗
    SET_CURRROUTE = 'SET_CURRROUTE', // 设置当前路由
    ADD_INCLUDE = 'ADD_INCLUDE', // 新增缓存组件
    DEL_INCLUDE = 'DEL_INCLUDE', // 删除缓存组件
    SET_MENU_WARNING = 'SET_MENU_WARNING', // 设置全局菜单提醒数据
    ADD_MENU_WARNING_ITEM = 'ADD_MENU_WARNING_ITEM', // 指定菜单提醒数加一
    MINUS_MENU_WARNING_ITEM = 'MINUS_MENU_WARNING_ITEM', // 指定菜单提醒数减一
    SET_IS_CONTRACTS = 'SET_IS_CONTRACTS', // 设置商户未完善法人信息提醒
}